
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M173.14 82.604C161.162 70.614 145.235 64.01 128.267 64c-34.98 0-63.438 28.448-63.448 63.427a63.26 63.26 0 008.468 31.708l-9 32.865 33.625-8.823a63.41 63.41 0 0030.323 7.719h.032c34.968 0 63.427-28.448 63.447-63.427 0-16.948-6.593-32.875-18.572-44.865m-44.875 97.583h-.021a52.625 52.625 0 01-26.844-7.343l-1.927-1.146-19.958 5.229 5.322-19.448-1.25-2c-5.28-8.385-8.062-18.094-8.062-28.052.01-29.062 23.667-52.719 52.76-52.719 14.084.01 27.323 5.5 37.282 15.47 9.958 9.957 15.437 23.207 15.427 37.29-.01 29.074-23.667 52.72-52.73 52.72m28.928-39.48c-1.594-.791-9.386-4.635-10.834-5.156-1.458-.531-2.51-.792-3.573.792-1.052 1.583-4.093 5.156-5.02 6.208-.927 1.063-1.844 1.198-3.427.396-1.594-.792-6.698-2.458-12.75-7.865-4.72-4.198-7.896-9.385-8.823-10.979-.927-1.583-.094-2.437.698-3.229.708-.708 1.583-1.854 2.375-2.781.791-.927 1.052-1.584 1.583-2.646.531-1.052.27-1.98-.125-2.77-.406-.793-3.573-8.595-4.896-11.772-1.281-3.083-2.594-2.666-3.562-2.718a70.096 70.096 0 00-3.042-.053c-1.052 0-2.77.396-4.23 1.98-1.447 1.583-5.54 5.427-5.54 13.218 0 7.802 5.676 15.344 6.468 16.396.791 1.063 11.177 17.073 27.083 23.938 3.781 1.625 6.74 2.604 9.042 3.333 3.791 1.208 7.25 1.031 9.979.625 3.052-.448 9.385-3.833 10.698-7.531 1.323-3.709 1.323-6.875.927-7.542-.396-.656-1.448-1.052-3.031-1.844","fill":"#FFF","fill-rule":"evenodd","stroke-miterlimit":"10","font-family":"none","font-weight":"none","font-size":"none","text-anchor":"none"}})])
          )
        }
      }
    